import React, { useState, useEffect } from "react";
import { Card, Button, FormGroup, Input, Col, Row, CardBody } from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";
import {
  GET_ORG_REGULATION,
  DELETE_ORG_REGULATION,
  REGISTER_MAIL,
  UPDATE_REGULATION,
} from "../../../queries";
import { useMutation, useQuery } from "@apollo/client";
import * as Ionicons from "react-icons/io";

import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import ReactTable from "react-table";
import {
  useMyOrgInfo,
  useUserInfo,
} from "../../../Layout/AppMain/LoginStatusContext";
import DropdownIsHold from "./Components/DropdownIsHold";
import DropdownIsOpen from "./Components/DropdownIsOpen";
import EditLink from "./Components/EditLink";
import EditPdf from "./Components/EditPdf";

const SettingOrgTab4 = ({ orgPk }) => {
  const CloseIcon = Ionicons["IoIosClose"];
  const myOrgInfo = useMyOrgInfo();
  const myPage = myOrgInfo.pk == orgPk;
  const userInfo = useUserInfo();
  const { ability } = userInfo;

  const { id } = useMyOrgInfo();
  const SettingIcon = Ionicons["IoIosSettings"];
  const SyncIcon = Ionicons["IoIosSync"];

  //編集ボタン
  const [editAble, setEditAble] = useState(false);
  const buttonToggle = () => setEditAble(!editAble);

  const { loading, error, data, refetch } = useQuery(GET_ORG_REGULATION, {
    variables: { org_id: orgPk },
  });

  // PDF、リンク削除Mutation
  const [deleteOrgRegulation] = useMutation(DELETE_ORG_REGULATION);
  const deleteRegulation = async (regId) => {
    await deleteOrgRegulation({
      variables: {
        userId: userInfo.id,
        orgId: id,
        orgRegulationId: regId,
      },
    });
    await refetch();
  };

  let newArry = [];

  const regulationCategory =
    data &&
    data.regulationCategory &&
    data.regulationCategory.edges &&
    data.regulationCategory.edges.map((array) =>
      array.node.regulation.edges.map((array2) => newArry.push(array2.node))
    );

  return (
    <div>
      <Card className="mb-2  org_contentarea">
        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              情報開示
            </h4>
          </div>
          {myPage && ability == "can_edit" && (
            <>
              {editAble ? (
                <Button onClick={buttonToggle} className="ema__btn__update">
                  <CloseIcon fontSize="17px" />
                </Button>
              ) : (
                <Button onClick={buttonToggle} className="ema__btn__edit">
                  <SettingIcon fontSize="20px" />
                  <span className="pl-2">情報の編集</span>
                </Button>
              )}
            </>
          )}
        </div>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col md="12">
              <CardBody>
                <ReactTable
                  getTdProps={(state, rowInfo, column, instance) => {
                    return {
                      onClick: (e) => {
                        //if(column.id !== 'col-check'){
                        // 基本的な処理
                        //  return
                        //}
                      },
                    };
                  }}
                  data={newArry}
                  columns={[
                    {
                      Header: "カテゴリー",
                      accessor: "category",

                      Cell: ({ row }) => {
                        return (
                          <div style={{ textAlign: "center", width: "100%" }}>
                            {row._original.orgRegulation.edges.map(
                              (arry) => arry.node.regulation.category.title
                            )}
                          </div>
                        );
                      },
                    },
                    {
                      Header: "項目",
                      accessor: "name",
                      id: "row",
                      Cell: ({ row }) => {
                        return (
                          <div style={{ textAlign: "center", width: "100%" }}>
                            {row._original.title}
                          </div>
                        );
                      },
                    },
                    {
                      Header: "有無",
                      accessor: "hold",
                      width: 100,
                      Cell: ({ row }) => {
                        return (
                          <>
                            <div style={{ textAlign: "center", width: "100%" }}>
                              {row._original.orgRegulation.edges.map((arry) => (
                                <>
                                  <div className="m-2">
                                    {arry.node.isHold === true ? (
                                      <div>◯</div>
                                    ) : (
                                      <div>-</div>
                                    )}
                                  </div>
                                </>
                              ))}
                              {editAble ? (
                                <DropdownIsHold
                                  regulationId={row._original.id}
                                  refetch={refetch}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        );
                      },
                    },
                    {
                      Header: "開示",
                      accessor: "open",
                      width: 100,
                      Cell: ({ row }) => {
                        return (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {row._original.orgRegulation.edges.map((arry) => (
                                <div className="m-2">
                                  {arry.node.isOpen === true ? (
                                    <div>◯</div>
                                  ) : (
                                    <div>-</div>
                                  )}
                                </div>
                              ))}
                              {editAble ? (
                                <DropdownIsOpen
                                  regulationId={row._original.id}
                                  refetch={refetch}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        );
                      },
                    },
                    {
                      Header: "掲載ページ",
                      accessor: "link",

                      Cell: ({ row }) => {
                        return (
                          <>
                            <div style={{ textAlign: "center", width: "100%" }}>
                              {row._original.orgRegulation.edges.map((arry) => (
                                <>
                                  <div className="btnArea">
                                    <a
                                      href={arry.node.pdf}
                                      className={`pdfBtn ${
                                        arry.node.pdfName ? "" : "disabled"
                                      }`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {editAble ? (
                                        arry.node.pdfName ? (
                                          <>arry.node.pdfName</>
                                        ) : (
                                          "None"
                                        )
                                      ) : (
                                        "PDF"
                                      )}
                                    </a>

                                    <a
                                      href={arry.node.url}
                                      className={`pdfBtn ${
                                        arry.node.url === null ? "disabled" : ""
                                      }`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {editAble
                                        ? arry.node.url
                                          ? arry.node.url
                                          : "None"
                                        : "リンク"}
                                    </a>
                                  </div>
                                  {editAble ? (
                                    <div className="py-1">
                                      <div>
                                        <EditPdf
                                          id={id}
                                          regulationId={row._original.id}
                                          refetch={refetch}
                                        />
                                        <EditLink
                                          id={id}
                                          regulationId={row._original.id}
                                          refetch={refetch}
                                          link={row._original.url}
                                          onDelete={() => {
                                            deleteRegulation(arry.node.id);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ))}
                            </div>
                          </>
                        );
                      },
                    },
                  ]}
                  defaultPageSize={25}
                  className="-striped -highlight"
                  previousText="前へ"
                  nextText="次へ"
                  pageText=""
                  ofText="情報開示"
                  rowsText=""
                  style={{ cursor: "pointer" }}
                />
              </CardBody>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Card>
    </div>
  );
};

export default SettingOrgTab4;
